import React from "react";

function DownArrow() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="9"
      height="6"
      fill="none"
      viewBox="0 0 9 6"
    >
      <path
        stroke="#052f35 "
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M1 1.5l3.5 3 3.5-3"
      ></path>
    </svg>
  );
}

export default DownArrow;